import React from 'react';
import PropTypes from 'prop-types';
import { computeTextDiff } from '../utils/documentDiff';
import './InlineDiffView.css';

/**
 * Shows a visual diff directly in the editor area
 * Displays changes with strikethrough (red) for deletions and underline (green) for additions
 */
const InlineDiffView = ({ oldContent, newContent }) => {
  const diff = computeTextDiff(oldContent || '', newContent || '');
  
  return (
    <div className="inline-diff-view">
      <div className="inline-diff-header">
        <span className="diff-badge">Preview Changes</span>
        <div className="inline-diff-legend">
          <span className="legend-item">
            <span className="deleted-text">Deleted</span>
          </span>
          <span className="legend-item">
            <span className="added-text">Added</span>
          </span>
        </div>
      </div>
      <div className="inline-diff-content">
        {diff.map((line, idx) => {
          if (line.type === 'delete') {
            return (
              <span key={idx} className="deleted-text">
                {line.content}
              </span>
            );
          } else if (line.type === 'insert') {
            return (
              <span key={idx} className="added-text">
                {line.content}
              </span>
            );
          } else {
            return (
              <span key={idx} className="unchanged-text">
                {line.content}
              </span>
            );
          }
        })}
      </div>
    </div>
  );
};

InlineDiffView.propTypes = {
  oldContent: PropTypes.string,
  newContent: PropTypes.string,
};

export default InlineDiffView;

